export var TOKEN_STATUSES = [
    "DRAFT",
    "LISTED",
    "PAUSED",
    "DELISTED",
];
export var TOKEN_STATUS_LABELS = {
    DRAFT: "Draft",
    LISTED: "Listed",
    PAUSED: "Paused",
    DELISTED: "Delisted",
};
export var TOKEN_CATEGORIES = [
    { value: "real-estate", label: "Real Estate" },
    { value: "residential", label: "Residential" },
    { value: "commercial", label: "Commercial" },
    { value: "development", label: "Development" },
    { value: "land", label: "Land" },
    { value: "industrial", label: "Industrial" },
    { value: "hospitality", label: "Hospitality" },
];
export var TOKEN_REGIONS = [
    { value: "north-america", label: "North America" },
    { value: "south-america", label: "South America" },
    { value: "africa", label: "Africa" },
    { value: "europe", label: "Europe" },
    { value: "asia", label: "Asia" },
    { value: "oceania", label: "Oceania" },
];
export var TOKEN_NETWORKS = [
    { value: "BSC", label: "BSC" },
    { value: "ETHEREUM", label: "Ethereum" },
    { value: "POLYGON", label: "Polygon" },
    { value: "BASE", label: "Base" },
];
